import axiosInstance from "./axiosInstance";
import { getAuthHeader } from "./permissionService";

export interface MenuItemPayload {
  name: string;
  code: string;
  description: string;
  isActive: boolean;
}

export interface MawaidMenuItem extends MenuItemPayload {
  publicId: string;
}

export const createMenuItem = async (payload: MenuItemPayload) => {
  const response = await axiosInstance.post("/mawaid/menu-items", payload, {
    headers: getAuthHeader(),
  });
  if (response.data?.success === false) {
    throw new Error(response.data.message || "Menu item request failed");
  }
  return response.data;
};

export const updateMenuItem = async (
  publicId: string,
  payload: MenuItemPayload,
) => {
  const response = await axiosInstance.put(
    `/mawaid/menu-items/${publicId}`,
    payload,
    { headers: getAuthHeader() },
  );
  if (response.data?.success === false) {
    throw new Error(response.data.message || "Menu item request failed");
  }
  return response.data;
};

export const deleteMenuItem = async (publicId: string) => {
  const response = await axiosInstance.delete(
    `/mawaid/menu-items/${publicId}`,
    { headers: getAuthHeader() },
  );
  if (response.data?.success === false) {
    throw new Error(response.data.message || "Menu item request failed");
  }
  return response.data;
};

export interface MenuItemSearchQuery {
  Name?: string;
  Code?: string;
  IsActive?: boolean;
  PageNumber: number;
  PageSize: number;
}

export interface MenuItemSearchPage {
  pageNumber: number;
  pageSize: number;
  totalRecords: number;
  totalPages: number;
  hasPreviousPage: boolean;
  hasNextPage: boolean;
  success: boolean;
  message: string;
  data: MawaidMenuItem[];
}

export const searchMenuItems = async (
  params: MenuItemSearchQuery,
  signal?: AbortSignal,
): Promise<MenuItemSearchPage> => {
  const response = await axiosInstance.get<{
    success: boolean;
    message: string;
    data: MenuItemSearchPage;
  }>("/mawaid/menu-items/search", { params, signal, headers: getAuthHeader() });
  if (response.data.success === false) {
    throw new Error(response.data.message || "Failed to load menu items");
  }
  if (response.data.data?.success === false) {
    throw new Error(response.data.data.message || "Failed to load menu items");
  }
  return response.data.data;
};
